import eventTemplate from './EgTemplates';

const PAGE_NAME = 'Property Onboarding';

export const EventType = {
    Impression: 'Impression',
    Interaction: 'Interaction',
    Outcome: 'Outcome',
    PageView: 'Page View'
};

export const egClickstreamMap = {
    pageview: true,
    interaction: true,
    outcome: true,
    impression: true
};

export const createImpressionEvent = (action, pageName, pageNameDetailed, eventVersion = '1.0.0') => {
    const options = {
        experience: {
            page_name: pageName,
            page_name_detailed: pageNameDetailed
        },
        event: {
            event_name: action,
            event_version: eventVersion,
            event_type: EventType.Impression,
            tenant: 'PartnerCentralClickstream'
        }
    };
    return eventTemplate.createEvent(options);
};

export const logPinMapMovement = (
    { country, city },
    { lat, lng },
    pageName,
    brand
) => {
    const options = {
        experience: {
            page_name_detailed: pageName,
            page_name: PAGE_NAME
        },
        event: {
            event_name: 'property_location_pin_map.updated',
            event_version: '2.3.0',
            tenant: 'PartnerCentralClickstream',
            event_type: EventType.Interaction
        }
    };
    const attributes = {
        product_list: [{
            lodging_product: {
                property_city_name: city,
                property_country_name: country,
                property_type: brand === 'expedia' ? 'Conventional Lodging' : 'Vacation Rental'
            }
        }],
        destination: {
            destination_latitude: lat,
            destination_longitude: lng
        }
    };
    return eventTemplate.createCustomEvent(attributes, eventTemplate.createEvent(options));
};

export const logLocationErrorEvent = (
    { country, city },
    // eslint-disable-next-line camelcase
    { error_name, error_description },
    pageName,
    brand
) => {
    const options = {
        experience: {
            page_name_detailed: pageName,
            page_name: PAGE_NAME
        },
        event: {
            event_name: 'location_error.presented',
            event_version: '2.3.0',
            tenant: 'PartnerCentralClickstream',
            event_type: EventType.Impression
        }
    };

    const attributes = {
        product_list: [{
            lodging_product: {
                property_city_name: city,
                property_country_name: country,
                property_type: brand !== 'vrbo' ? 'Conventional Lodging' : 'Vacation Rental'
            }
        }],
        error_list: [{
            error_name,
            error_description
        }]
    };
    return eventTemplate.createCustomEvent(attributes, eventTemplate.createEvent(options));
};

export const logLocationInformationEvent = ({ country, city }, pageName, CL = 'vrbo') => {
    const options = {
        experience: {
            page_name_detailed: pageName,
            page_name: PAGE_NAME
        },
        event: {
            event_name: 'location_information.submitted',
            event_version: '2.3.0',
            tenant: 'PartnerCentralClickstream',
            event_type: EventType.Interaction
        }
    };

    const attributes = {
        product_list: [{
            lodging_product: {
                property_city_name: city,
                property_country_name: country,
                property_type: CL !== 'vrbo' ? 'Conventional Lodging' : 'Vacation Rental'
            }
        }]
    };

    return eventTemplate.createCustomEvent(attributes, eventTemplate.createEvent(options));
};

export const createInteractionEvent = (
    action, pageName, pageNameDetailed, actionLocation, eventVersion
) => {
    const options = {
        experience: {
            page_name: pageName,
            page_name_detailed: pageNameDetailed
        },
        event: {
            event_name: action,
            event_version: eventVersion || '1.0.0',
            event_type: EventType.Interaction,
            tenant: 'PartnerCentralClickstream',
            action_location: actionLocation || undefined
        }
    };
    return eventTemplate.createEvent(options);
};

export const createOutcomeEvent = (action, pageName, pageNameDetailed, userId,
    eventVersion, additionalInfo = {}) => {
    const { event: additionalEvent } = additionalInfo;
    const options = {
        experience: {
            page_name: pageName,
            page_name_detailed: pageNameDetailed
        },
        event: {
            event_name: action,
            event_version: eventVersion || '1.0.0',
            event_type: EventType.Outcome,
            tenant: 'PartnerCentralClickstream',
            ...(additionalEvent ?? {})
        }
    };
    return eventTemplate.createEvent(options, userId);
};

export const createPageViewEvent = (pageName, pageNameDetailed = '', eventVersion) => {
    const createPageViewEventName = () => pageName
        .replace(/ V\d+/g, '')
        .replace(/-| - | /g, '_')
        .replace(/[A-Z]/g, capitalLetter => capitalLetter.toLowerCase())
        .concat('.viewed');
    const options = {
        experience: {
            page_name: pageName,
            page_name_detailed: pageNameDetailed
        },
        event: {
            event_name: createPageViewEventName(),
            event_version: eventVersion || '1.0.0',
            event_type: EventType.PageView,
            tenant: 'PartnerCentralClickstream'
        }
    };
    return eventTemplate.createEvent(options);
};

export default {
    egClickstreamMap,
    logLocationInformationEvent,
    logLocationErrorEvent,
    createInteractionEvent,
    createPageViewEvent,
    createOutcomeEvent
};
